import { FC } from 'react';

import { css } from '@emotion/react';
import { Alert, AlertTitle, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { useExtensionConfig } from '~/hooks/useExtensionConfig';

import Link from './Link';

interface InstallExtensionAlertProps {
  className?: string;
}

const InstallExtensionAlert: FC<InstallExtensionAlertProps> = ({ className }) => {
  const theme = useTheme();
  const { browserName, storeUrl } = useExtensionConfig();
  const { t } = useTranslation();

  return (
    <Alert
      severity="info"
      className={className}
      css={css`
        margin-bottom: ${theme.spacing(4)};
      `}
    >
      <AlertTitle>{t('sharedInstallExtensionTitle')}</AlertTitle>
      {t('sharedInstallExtensionCopy')}
      <Link
        href={storeUrl}
        css={css`
          margin-top: ${theme.spacing(1)};
          display: block;
          width: fit-content;
        `}
      >
        {t('sharedInstallExtensionLink', { browserName })}
      </Link>
    </Alert>
  );
};

export default InstallExtensionAlert;
